<template>
    <iframe
        ref="iframe"
        :key="iframeKey"
        :src="iframeSrc"
        style="width: 100%; height: 100%; border: none;"
    ></iframe>
</template>



<script>
    import { isDevEnv } from '@/utils/util';

    export default {
        name: 'LandingPagePreview',
        props: {
            id: {
                type: Number,
            },
            sid: {
                type: Number,
            },
            oid: {
                type: Number,
            },
            number: {
                type: [Number, String],
            },
            name: {
                type: String,
            },
            lp: {
                type: Number,
            },
        },
        data() {
            const baseUrl = isDevEnv ? 'https://bbwidgetscriptsdev.z6.web.core.windows.net' : 'https://gdziekupic.to';
            return {
                baseUrl,
                iframeKey: 0,
                resizeObserver: null,
            };
        },
        computed: {
            iframeSrc() {
                const paramKeys = ['id', 'sid', 'oid', 'number', 'name', 'lp'];
                const params = paramKeys
                    .filter(key => Number.isInteger(Number.parseInt(this[key])))
                    .map(key => `${key}=${this[key]}`)
                    .join('&');
                return `${this.baseUrl}/buybox.html?${params}`;
            },
        },
        methods: {
            reloadLandingPage() {
                // Zwiększamy klucz iframe, aby wymusić jego ponowne renderowanie
                this.iframeKey += 1;
            },
        },
    };
</script>
